var _ellipse, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBtnArrowThin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 20.8599,
    cy: 21.1765,
    rx: 20.2548,
    ry: 20.2941,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.35018 20.4694C8.95965 20.8599 8.95965 21.4931 9.35018 21.8836L15.7141 28.2475C16.1047 28.6381 16.7378 28.6381 17.1284 28.2475C17.5189 27.857 17.5189 27.2238 17.1284 26.8333L11.4715 21.1765L17.1284 15.5196C17.5189 15.1291 17.5189 14.4959 17.1284 14.1054C16.7378 13.7149 16.1047 13.7149 15.7141 14.1054L9.35018 20.4694ZM33.0127 20.1765L10.0573 20.1765L10.0573 22.1765L33.0127 22.1765L33.0127 20.1765Z",
    fill: "#263D4F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnArrowThin);
export default __webpack_public_path__ + "static/media/btn_arrow_thin.673d45a8e345aa131f49280472db4e54.svg";
export { ForwardRef as ReactComponent };